import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-base" }, /*#__PURE__*/_toDisplayString(`Variant`), -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "text-black" }, "$", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-black" }, "$", -1)
const _hoisted_4 = { class: "Shipping-cost" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "First", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Additional", -1)
const _hoisted_7 = { class: "dialog-footer" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("  Cancel ")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode("  Save ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.dialogVisible) = $event)),
    class: "font-bold",
    width: "40%"
  }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_7, [
        _createVNode(_component_el_button, {
          onClick: _ctx.close,
          loading: _ctx.loading
        }, {
          default: _withCtx(() => [
            _hoisted_8,
            _hoisted_9
          ]),
          _: 1
        }, 8, ["onClick", "loading"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.onSubmit,
          loading: _ctx.loading
        }, {
          default: _withCtx(() => [
            _hoisted_10,
            _hoisted_11
          ]),
          _: 1
        }, 8, ["onClick", "loading"])
      ])
    ]),
    default: _withCtx(() => [
      _withDirectives(_createVNode(_component_el_form, {
        model: _ctx.state.formVariant,
        ref: "catalogVariantForm",
        "label-width": "120px",
        rules: _ctx.rules
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "Variant Code",
            class: "font-bold",
            prop: "catalogVariantCode"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.state.formVariant.catalogVariantCode,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.formVariant.catalogVariantCode) = $event)),
                autocomplete: "off",
                placeholder: "Enter variant code"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Variant Code",
            class: "font-bold",
            prop: "catalogVariantFactoryCode"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.state.formVariant.catalogVariantFactoryCode,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.formVariant.catalogVariantFactoryCode) = $event)),
                autocomplete: "off",
                placeholder: "Enter factory code"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          (_ctx.colorsValue && _ctx.colorsValue.length > 0)
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: "Color",
                class: "font-bold",
                prop: "colorCode"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    disabled: "",
                    autocomplete: "off",
                    placeholder: 
            _ctx.colorsValue.find(s => s.code === _ctx.state.formVariant.colorCode).name
          
                  }, null, 8, ["placeholder"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.sizesValue && _ctx.sizesValue.length > 0)
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 1,
                label: "Size",
                class: "font-bold",
                prop: "sizeCode"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    disabled: "",
                    placeholder: 
            _ctx.sizesValue.find(s => s.code === _ctx.state.formVariant.sizeCode).name
          ,
                    autocomplete: "off"
                  }, null, 8, ["placeholder"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, {
            label: "Status",
            class: "font-bold",
            prop: "inStock"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.state.formVariant.inStock,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.formVariant.inStock) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
              { value: true, title: 'In Stock' },
              { value: false, title: 'Out of stock' },
            ], (item) => {
                    return _createVNode(_component_el_option, {
                      key: item.value,
                      label: item.title,
                      value: item.value,
                      size: 25
                    }, null, 8, ["label", "value"])
                  }), 64))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Artworks",
            class: "font-bold",
            prop: "designs"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                class: "w-full",
                multiple: "",
                modelValue: _ctx.state.formVariant.designs,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.formVariant.designs) = $event)),
                placeholder: "Please select a artworks",
                clearable: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.designs, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.name,
                      label: item.name,
                      value: item.name,
                      size: 25
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Cost",
            class: "font-bold",
            prop: "cost"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.state.formVariant.cost,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.formVariant.cost) = $event)),
                autocomplete: "off",
                type: "number"
              }, {
                prefix: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Design cost",
            class: "font-bold",
            prop: "designCost"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.state.formVariant.designCost,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.formVariant.designCost) = $event)),
                autocomplete: "off",
                type: "number"
              }, {
                prefix: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_row, { class: "py-2.5 my-2" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  md: 3,
                  offset: 3
                }),
                _createVNode(_component_el_col, { md: 8 }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { md: 8 }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { md: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "Ship US",
                      class: "font-bold",
                      prop: "shipUsFirst"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          modelValue: _ctx.state.formVariant.shipUsFirst,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.formVariant.shipUsFirst) = $event)),
                          min: 0,
                          max: 1000000,
                          "controls-position": "right"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { md: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      class: "font-bold",
                      prop: "shipUsAdditional"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          modelValue: _ctx.state.formVariant.shipUsAdditional,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.formVariant.shipUsAdditional) = $event)),
                          min: 0,
                          max: 1000000,
                          "controls-position": "right"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { md: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "Ship ROW",
                      class: "font-bold",
                      prop: "shipRowFirst"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          modelValue: _ctx.state.formVariant.shipRowFirst,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.formVariant.shipRowFirst) = $event)),
                          min: 0,
                          max: 1000000,
                          "controls-position": "right"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { md: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      class: "font-bold",
                      prop: "shipRowAdditional"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          modelValue: _ctx.state.formVariant.shipRowAdditional,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.formVariant.shipRowAdditional) = $event)),
                          min: 0,
                          max: 1000000,
                          "controls-position": "right"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Supplier Code",
              class: "font-bold",
              prop: "supplierCode"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, { gutter: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.state.formVariant.supplierCode.code,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.formVariant.supplierCode.code) = $event)),
                          autocomplete: "off",
                          placeholder: "Enter supplier code"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          modelValue: _ctx.state.formVariant.supplierCode.quantity,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.formVariant.supplierCode.quantity) = $event)),
                          placeholder: "Enter quantity",
                          min: 0,
                          max: 1000000,
                          "controls-position": "right"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["model", "rules"]), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}